import { t } from '@lingui/core/macro';
import { SearchProjectFilter } from './SearchProjectFilter';
import { withFilterErrorBoundary } from '../FilterErrorBoundary';
export const documentProjectsFilterLabel = () => t({ message: 'Project', comment: 'Insights filter: Project' });
export const DocumentProjectsFilter = withFilterErrorBoundary(() => (<SearchProjectFilter name="metadataDocumentProjectIds" label={documentProjectsFilterLabel()}/>));
